import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { Subscriber } from 'shell/models/subscriber';
import { noop } from 'shell/utils/noop';
import SubscriberFormComponent from 'system/components/subscriber/form';
import { subscriberCrumbs } from '../constants';
import { transformSubscriber, transformSubsciberResponse } from '../utils/transform-subscriber';

const SubscriberDetailPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/sistema/eventmanager/sottoscrittore');
  };

  const params = useParams();

  const [subscriber] = useHttpFetch<HttpResponse<Subscriber>, transformSubsciberResponse>(
    `${__OPERATION__EVENT__ADMIN__}/sottoscrittore/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformSubscriber,
    }
  );

  return (
    <>
      <Breadcrumbs items={[...subscriberCrumbs, { name: 'Dettaglio Sottoscrittore' }]} />
      <SubscriberFormComponent
        forminitialValues={subscriber.data as transformSubsciberResponse}
        title="Dettaglio"
        onOk={noop}
        disabled
        onCancel={onCancel}
      />
    </>
  );
};

SubscriberDetailPage.displayName = 'Subscriber Detail Page';
export default SubscriberDetailPage;
